import React from "react";
import DeviceFiltersForm from "./DeviceFilterForm";

const DeviceFilter: React.FC = () => {
  return <DeviceFiltersForm />;
};

export default DeviceFilter;
